<div class="login">
  <div class="col-12">
    <label for="username" class="visually-hidden">Username</label>
    <input
      id="username"
      type="text"
      placeholder="Username"
      class="input-text"
      (keyup.enter)="login()"
      [(ngModel)]="username"
    />
    <label for="password" class="visually-hidden">Password</label>
    <input
      id="password"
      type="password"
      placeholder="Password"
      class="input-text"
      (keyup.enter)="login()"
      [(ngModel)]="password"
    />

    <div
      class="options d-flex flex-column justify-content-center gap-2 align-items-center mt-3"
    >
      <button
        class="button btn-login primary w-100"
        (click)="login()"
        [disabled]="loading()"
      >
        Login
      </button>
      <button
        class="button btn-passkey"
        [disabled]="loading()"
        (click)="loginDiscord()"
      >
        <span class="fini-icon-svg discord-icon"></span>
        Login with Discord
      </button>
      @if (!isProduction()) {
        <fini-tooltip class="w-100">
          <button
            class="button btn-passkey"
            [disabled]="loading()"
            (click)="loginPasskey()"
          >
            <span class="fini-icon-svg passkey-icon"></span>
            Login with Passkey
          </button>
          <span content>Username required to login with Passkey</span>
        </fini-tooltip>
      }
    </div>
  </div>
  <mat-progress-bar
    [class.visually-hidden]="!loading()"
    class="top-loading-bar"
    mode="indeterminate"
  ></mat-progress-bar>
</div>
